var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQaicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 37,
    r: 37,
    fill: "#85DBD7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 12C33.7308 12 31.2308 14.5 31.2308 17.7692V29.3077C31.2308 32.5769 33.7308 35.0769 37 35.0769H48.5385L56.2308 42.7692V35.0769C59.5 35.0769 62 32.5769 62 29.3077V17.7692C62 14.5 59.5 12 56.2308 12H37ZM45.0538 17.7692H48.3577L51.6038 29.3077H48.7192L47.9365 26.4231H45.0519L44.3327 29.3077H41.8077L45.0538 17.7692ZM46.6154 19.6923C46.4231 20.4615 46.2077 21.4 46.0135 21.9769L45.475 24.5H47.7577L47.2154 21.975C46.8327 21.4 46.6154 20.4615 46.6154 19.6923ZM17.7692 31.2308C14.5 31.2308 12 33.7308 12 37V48.5385C12 51.8077 14.5 54.3077 17.7692 54.3077V62L25.4615 54.3077H37C40.2692 54.3077 42.7692 51.8077 42.7692 48.5385V37H37C33.3462 37 30.45 34.5 29.4885 31.2308H17.7692ZM26.6038 36.8192C29.8731 36.8192 31.4115 39.5115 31.4115 42.5885C31.4115 45.2808 30.4865 46.9885 28.9481 47.7577C29.7173 48.1423 30.6288 48.3462 31.5904 48.5385L30.8712 50.4615C29.525 50.0769 28.1288 49.4769 26.7827 48.8981C26.5904 48.7058 26.2538 48.7192 26.0615 48.7192C23.7538 48.5269 21.6154 46.6154 21.6154 42.7692C21.6154 39.5 23.5269 36.8192 26.6038 36.8192ZM26.6038 38.9231C25.0654 38.9231 24.3192 40.6538 24.3192 42.7692C24.3192 45.0769 25.0654 46.6154 26.6038 46.6154C28.1423 46.6154 28.9462 44.8846 28.9462 42.7692C28.9462 40.6538 28.1423 38.9231 26.6038 38.9231Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQaicon);
export default __webpack_public_path__ + "static/media/qaicon.a0847ebdc7a6e49724147585981b685b.svg";
export { ForwardRef as ReactComponent };